import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Container } from 'react-bootstrap';

import api from '../../services/api';

import Loading from '../../components/Loading';
import { TIPO_USUARIO } from '../../utils/funcoes';

import { useAuth } from '../../hooks/auth';

const Configuracao: React.FC = () => {
  const history = useHistory();
  const { user, clinica } = useAuth();

  const permissoes = user.UsuPermissao.split(',');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get('sessions/logado');
        console.log(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, []);

  useEffect(() => {
    if (
      user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA &&
      permissoes.length === 0
    ) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading backgroundBlack={false} />}
      <div className="bg-white border p-2 mb-2" style={{ minHeight: '400px' }}>
        <h2>Configurações do Sistema</h2>
        <p className="my-4">
          Gerencie usuários, permissões, imprima relatórios e outros através do
          menu administrativo
        </p>

        <table
          className="table table-hover table-bordered table-sm mt-3"
          style={{ fontSize: 'small' }}
        >
          <tr>
            <th colSpan={2}>Dados da Clínica</th>
          </tr>

          <tr>
            <td>NOME CLINICA</td>
            <td> {clinica.CliNome}</td>
          </tr>
          <tr>
            <td>NOME ABREVIADO CLINICA</td>
            <td> {clinica.CliNomeAbreviado}</td>
          </tr>
          <tr>
            <td>RAZAO SOCIAL</td>
            <td> {clinica.CliRazaoSocial}</td>
          </tr>
          <tr>
            <td>CNPJ CLINICA</td>
            <td> {clinica.CliCNPJ}</td>
          </tr>
          <tr>
            <td>REPRESENTANTE CLINICA</td>
            <td> {clinica.CliRepresentante}</td>
          </tr>
          <tr>
            <td>TELEFONE CLINICA</td>
            <td> {clinica.CliTelefone}</td>
          </tr>
          <tr>
            <td>TELEFONE2 CLINICA</td>
            <td> {clinica.CliTelefone2}</td>
          </tr>
          <tr>
            <td>CIDADE CLINICA</td>
            <td> {clinica.CliCidade}</td>
          </tr>
          <tr>
            <td>ESTADO CLINICA</td>
            <td> {clinica.CliUF}</td>
          </tr>
          <tr>
            <td>ENDERECO COMPLETO CLINICA</td>
            <td> {clinica.CliEndereco}</td>
          </tr>
          <tr>
            <td>EMAIL CLINICA</td>
            <td> {clinica.CliEmail}</td>
          </tr>
          <tr>
            <td>SITE CLINICA</td>
            <td> {clinica.CliSite}</td>
          </tr>
          <tr>
            <td>FACEBOOK CLINICA</td>
            <td> {clinica.CliFacebook}</td>
          </tr>
          <tr>
            <td>INSTAGRAM CLINICA</td>
            <td> {clinica.CliInstagram}</td>
          </tr>
        </table>
      </div>
    </Container>
  );
};

export default Configuracao;
